export default function toDollars(numeric: number | null | undefined): string {
    return new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD'
    }).format(numeric || 0);
}
